import { polyfill } from "es6-promise";
polyfill();

import PaginationApp from "./PaginationApp.vue";
import Vue from "vue";

import helperFunctions from "./es6/helper-functions/helper-functions.js";

Vue.config.productionTip = false;

// Vue Instance
const rootMenu = document.getElementById("js-pagination");
const helperFunction = new helperFunctions();
let providers = document.getElementById("providers-of-supplier-data").innerHTML;

providers = helperFunction.replaceSpecialCharacters(
  providers,
  /(&quot;)/g,
  '"'
);
providers = helperFunction.replaceSpecialCharacters(
  providers,
  /(&#039;)/g,
  "'"
);

// parse the providers json
providers = JSON.parse(providers);

if (rootMenu) {
  new Vue({
    el: "#js-pagination",
    computed: {},
    data: function () {
      return {
        providers: providers,
      };
    },
    render: function render(h) {
      return h(PaginationApp, {
        props: {
          providers: this.providers,
        },
      });
    },
  });
}
